import React, { forwardRef, useState } from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import BillingLinks from "./BillingLinks";
import InvoicingHistoryIcon from "../../assets/icons/invoice_history.svg2";
import PageHeader from "../Common/PageHeader";
import WhiteButton from "../Common/WhiteButton";
import Subheading from "../Common/Subheading";
import Table from "react-bootstrap/Table";
import Select from "react-select";
import { Col, FloatingLabel, Form, FormLabel } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import SearchIcon from "../../assets/icons/search.svg2";
import BillingIcon from "../../assets/icons/icon_reporting_financials_white-01.svg2";
import NewFeature from "../Builder/Components/NewFeature";
import HelpButton from "../HelpContent/HelpButton";

function CustomDatePickerInputFrom({ value, onClick, className }) {
  return (
    <FloatingLabel label="From">
      <Form.Control
        placeholder=""
        value={value}
        className={className}
        onClick={onClick}
      />
      ;
    </FloatingLabel>
  );
}

function CustomDatePickerInputTo({ value, onClick, className }) {
  return (
    <FloatingLabel label="To">
      <Form.Control
        placeholder=""
        value={value}
        className={className}
        onClick={onClick}
      />
      ;
    </FloatingLabel>
  );
}

export default function BillingInvoiceHistory() {
  const [invoicesSummary, setInvoicesSummary] = useState({
    type: " SUM",
    invQuantity: "0 ",
    subtotal: "£0.00",
    vat: "£0.00",
    total: "£0.00",
  });
  const [invoices, setInvoices] = useState([
    {
      id: "123",
      invoiceName: "Boomerang",
      status: "N/A",
      amount: "20",
      lastError: "",
      date: "",
      dueDate: "",
      action: "",
    },
  ]);
  const [invoicesStatus, setInvoicesStatus] = useState();
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [search, setSearch] = useState();
  const options = [
    { value: "all", label: "All" },
    { value: "cancelled", label: "cancelled" },
    { value: "new", label: "new" },
    { value: "created", label: "created" },
    { value: "exception", label: "exception" },
    { value: "processing", label: "processing" },
    { value: "intransfer", label: "in transfer" },
    { value: "failed", label: "failed" },
    { value: "paid", label: "paid" },
  ];

  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={InvoicingHistoryIcon}
            heading="Billing Invoice History"
            subheading=" All paid and outstanding bills"
          />{" "}
          <div className="d-flex flex-wrap gap-2">
            <WhiteButton
              as="RRLink"
              icon={ContactsIcon}
              to="/assets/contacts/fields"
              heading="Boomerang UI Sales"
            />
          </div>
        </div>
        <div className="fw-bold mb-3 my-3"> Invoices Summary</div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Type</th>
              <th>INV QUANTITY</th>
              <th>SUBTOTAL</th>
              <th>VAT</th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{invoicesSummary.type}</td>
              <td>{invoicesSummary.invQuantity}</td>
              <td>{invoicesSummary.subtotal}</td>
              <td>{invoicesSummary.vat}</td>
              <td>{invoicesSummary.total}</td>
            </tr>
          </tbody>
        </Table>
        <div className="fw-bold mb-3"> Invoices</div>
        <div className="row mb-3">
          <Col className="col-2">
            <FloatingLabel label="Status">
              <Form.Select
                className="basic-multi-select"
                value={invoicesStatus}
                onChange={(e) => setInvoicesStatus(e.target.value)}
              >
                {options.map((o) => (
                  <option value={o.value}>{o.label}</option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col className="col-3 ">
            <ReactDatePicker
              customInput={<CustomDatePickerInputFrom />}
              selected={dateFrom}
              onChange={(d) => setDateFrom(d)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
          <Col className="col-3 ">
            <ReactDatePicker
              customInput={<CustomDatePickerInputTo />}
              selected={dateTo}
              onChange={(d) => setDateTo(d)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
          <Col className="col-4">
            <div className="position-relative  w-50">
              <FloatingLabel label="Search">
                <input
                  placeholder="Search"
                  className="form-control"
                  style={{ height: 38, paddingRight: 40 }}
                  type="text"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </FloatingLabel>
              <SearchIcon
                width={30}
                heigth={30}
                className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
                style={{ marginRight: -10 }}
              />
            </div>
          </Col>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#ID</th>
              <th>Invoice Name</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Last Error</th>
              <th>Date</th>
              <th>Due Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((i) => (
              <tr>
                <td>{i.id}</td>
                <td>{i.invoiceName}</td>
                <td>{i.status}</td>
                <td>{i.amount}</td>
                <td>{i.lastError}</td>
                <td>{i.date}</td>
                <td>{i.dueDate}</td>
                <td>{i.action}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </NewFeature>
    </div>
  );
}
